export const LANG_EN_NAME = 'english';

export const LANG_EN_TRANS = {
    'Loading': 'Loading',
    'Dashboard': 'Dashboard',
    'My Equipment': 'My Equipment',
    'My Inventory': 'My Inventory',
    'Reports': 'Reports',
    'Admin': 'Admin',
    'TT Admin': 'TT Admin',
    'My Account': 'My Account',
    'Help': 'Help',
    'Inspections': 'Inspections',
    'New Inspection': 'New Inspection',
    'Find & Edit Inspection': 'Find & Edit Inspection',
    'Interpret Inspection': 'Interpret Inspection',
    'Inspection Planning': 'Inspection Planning',
    'Download Android App': 'Download Android App',
    'Full History': 'Full History',
    'Record an Action': 'Record an Action',
    'Meter Reading': 'Meter Reading',
    'Meter Change': 'Meter Change',
    'Setup New Equipment': 'Setup New Equipment',
    'Find & Edit Equipment': 'Find & Edit Equipment',
    'Relocate Equipment': 'Relocate Equipment',
    'Inventory': 'Inventory',
    'New Chain or Frame': 'New Chain or Frame',
    'Inspection Analysis': 'Inspection Analysis',
    'Component Life Performance': 'Component Life Performance',
    'Equipment Without Contacts': 'Equipment Without Contacts',
    'Login Statistics': 'Login Statistics',
    'Fleet Component Forecast': 'Fleet Component Forecast',
    'Home': 'Home',
    'Customer Contacts': 'Customer Contacts',
    'User Contacts': 'User Contacts',
    'Job Roles': 'Job Roles',
    'Components': 'Components',
    'Equipment': 'Equipment',
    'Branded Styles': 'Branded Styles',
    'Old Setup': 'Old Setup',
    'Preferences': 'Preferences',
    'Logout': 'Logout',
    'TrackCommander Documentation': 'TrackCommander Documentation',
    'What\'s New': 'What\'s New',
    'About': 'About',
    'Job Role Setup': 'Job Role Setup',
    'Job Role Permissions': 'Job Role Permissions',
    'Job Role Members': 'Job Role Members',
    'Position & Job Status': 'Position & Job Status',
    'Component Types': 'Component Types',
    'Setup Components': 'Setup Components',
    'Wear Limits (A,B,C,X)': 'Wear Limits (A,B,C,X)',
    'Wear Rate Formulas': 'Wear Rate Formulas',
    'Setup Families': 'Setup Families',
    'Setup Makes': 'Setup Makes',
    'Setup Models': 'Setup Models',
    'Customer': 'Customer',
    'User': 'User',
    'Search': 'Search',
    'Job Site': 'Job Site',
    'Equipment Serial/Unit No': 'Equipment Serial/Unit No',
    'Family': 'Family',
    'Make': 'Make',
    'Model': 'Model',
    'Fleet Overview': 'Fleet Overview',
    'Filter': 'Filter',
    'Filter Table': 'Filter Table',
    'Eval (L)': 'Eval (L)',
    'Eval (R)': 'Eval (R)',
    'Serial No.': 'Serial No.',
    'Unit No.': 'Unit No.',
    'SMU': 'SMU',
    'LTD': 'LTD',
    'Last Inspection Date': 'Last Inspection Date',
    'Back': 'Back',
    'Awaiting Interpretation': 'Awaiting Interpretation',
    'This machine has recently been inspected, but the report is not ready. Once interpreted, your PDF report will be available for download.': 'This machine has recently been inspected, but the report is not ready. Once interpreted, your PDF report will be available for download.',
    'Equipment Details': 'Equipment Details',
    'Download Report': 'Download Report',
    'Inspection Details': 'Inspection Details',
    'Find Inspection': 'Find Inspection',
    'Equipment History': 'Equipment History',
    'Record Action': 'Record Action',
    'Serial Number': 'Serial Number',
    'Unit Number': 'Unit Number',
    'Next Inspection Date': 'Next Inspection Date',
    'N/A': 'N/A',
    'Meter Reading (SMU)': 'Meter Reading (SMU)',
    'Life to Date (LTD)': 'Life to Date (LTD)',
    'Chain Serial Number (left)': 'Chain Serial Number (left)',
    'Frame Serial Number (left)': 'Frame Serial Number (left)',
    'Chain Serial Number (right)': 'Chain Serial Number (right)',
    'Frame Serial Number (right)': 'Frame Serial Number (right)',
    'Left Side Components': 'Left Side Components',
    'Worn (%)': 'Worn (%)',
    'Component': 'Component',
    'Part No.': 'Part No.',
    'Life Lived (CMU)': 'Life Lived (CMU)',
    'Remaining Life (100%)': 'Remaining Life (100%)',
    'Remaining Life (120%)': 'Remaining Life (120%)',
    'Install Date': 'Install Date',
    'Equipment SMU at Install': 'Equipment SMU at Install',
    'Component Hours at Install': 'Component Hours at Install',
    'Right Side Components': 'Right Side Components',
    'Ruler': 'Ruler',
    'Create Favourite': 'Create Favourite',
    'Component Overview': 'Component Overview',
    'Wear Rate Overview': 'Wear Rate Overview',
    'Recommendation': 'Recommendation',
    'Status': 'Status',
    'Job Status': 'Job Status',
    'Position': 'Position',
    'Type': 'Type',
    'Track Roller Values - ': 'Track Roller Values - ',
    'Left': 'Left',
    'Right': 'Right',
    'hrs': 'hrs',
    'No': 'No',
    'Yes': 'Yes',
    'Carrier Roller AVG': 'Carrier Roller AVG',
    'Track Roller AVG': 'Track Roller AVG',
    'Track Roller Worst': 'Track Roller Worst',
    'Outstanding Actions': 'Outstanding Actions',
    'Sprocket': 'Sprocket',
    'Rear Idler': 'Rear Idler',
    'Front Idler': 'Front Idler',
    'Shoe': 'Shoe',
    'Bush Turned': 'Bush Turned',
    'Bush': 'Bush',
    'Hours on Link': 'Hours on Link',
    'Link': 'Link',
    'Current SMU/Hourmeter': 'Current SMU/Hourmeter',
    'Site': 'Site',
    'Unit': 'Unit',
    'Serial': 'Serial',
    'Update to Current Selection': 'Update to Current Selection',
    'Setup Undercarriage': 'Setup Undercarriage',
    'On Equipment': 'On Equipment',
    'In Inventory': 'In Inventory',
    'Setup User': 'Setup User',
    'Setup Customer': 'Setup Customer',
    'Setup Job Site': 'Setup Job Site',
    'Observation Lists': 'Observation Lists',
    'Measurement Points': 'Measurement Points',
    'Switch App': 'Switch App',
    'Dashboard Overview': 'Dashboard Overview',
    'Enlarge ': 'Enlarge ',
    'Inspections Performed': 'Inspections Performed',
    'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above. ': 'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above. ',
    'Total Cost of Repairs': 'Total Cost of Repairs',
    'The current evaluation of all the components you can view based on their last inspection. Filter this data down using the search above. ': 'The current evaluation of all the components you can view based on their last inspection. Filter this data down using the search above. ',
    'Inspections are due by today date. This is based on what you searched for in total and not what you see in this page only. ': 'Inspections are due by today date. This is based on what you searched for in total and not what you see in this page only. ',
    'Inspections due': 'Inspections due',
    'undefined': 'undefined',
    'Next Inspection Date SMU/Hourmeter': 'Next Inspection Date SMU/Hourmeter',
    'Last Inspection SMU/Hourmeter': 'Last Inspection Date:SMU/Hourmeter',
    'SMU/Hourmeter': 'SMU/Hourmeter',
    'Fleet Condition': 'Fleet Condition',
    'Equipment Overview': 'Equipment Overview',
    'Meter Reading (SMU/HourMeter)': 'Meter Reading (SMU/HourMeter)',
    'Setup Date': 'Setup Date',
    'Details': 'Details',
    'Edit': 'Edit',
    'Interpret': 'Interpret',
    'Inspection History': 'Inspection History',
    'Change Meter Unit': 'Change Meter Unit',
    'Update Meter': 'Update Meter',
    'Life Lived': 'Life Lived',
    'Equipment SMU/Hourmeter at Install': 'Equipment SMU/Hourmeter at Install',
    'Date Installed': 'Date Installed',
    'Total Component Repairs Cost (inc. All Components Ever)': 'Total Component Repairs Cost (inc. All Components Ever)',
    'Total Purchase Cost (inc. Current Components)': 'Total Purchase Cost (inc. Current Components)',
    'Right Side Frame': 'Right Side Frame',
    'Right Side Chain': 'Right Side Chain',
    'Left Side Frame': 'Left Side Frame',
    'Left Side Chain': 'Left Side Chain',
    'PDF Report': 'PDF Report',
    'Tasks': 'Tasks',
    'Change Jobsite': 'Change Jobsite',
    'Setup Equipment': 'Setup Equipment',
    'Next Inspection': 'Next Inspection',
    'Brand': 'Brand',
    '(CMU)': '(CMU)',
    '(100% Worn)': '(100% Worn)',
    '(120% Worn)': '(120% Worn)',
    'Purchase Cost': 'Purchase Cost',
    'Repairs Cost': 'Repairs Cost',
    'Interpretation': 'Interpretation',
    'Manage Equipment': 'Manage Equipment',
    'Meter Reading (SMU/Hourmeter)': 'Meter Reading (SMU/Hourmeter)',
    'Forward Travel Km': 'Forward Travel Km',
    'Reverse Travel Km': 'Reverse Travel Km',
    'Forward Hours': 'Forward Hours',
    'Reverse Hours': 'Reverse Hours',
    'JobSite Comment': 'JobSite Comment',
    'Inspection Comment': 'Inspection Comment',
    'Inspector': 'Inspector',
    'Inspection Date': 'Inspection Date',
    'Track Sag': 'Track Sag',
    'Cannon Ext.': 'Cannon Ext.',
    'Dry Joints': 'Dry Joints',
    'Scallop': 'Scallop',
    'Add Comment': 'Add Comment',
    'Interpretation Comment': 'Interpretation Comment',
    'Create New Quote': 'Create New Quote',
    'There are currently no quotes.': 'There are currently no quotes.',
    'Quotes': 'Quotes',
    'Bar Chart': 'Bar Chart',
    'Additional Observations': 'Additional Observations',
    'Audit Log': 'Audit Log',
    'Quote': 'Quote',
    'Release': 'Release',
    'Release Report to Customer': 'Release Report to Customer',
    'PDF': 'PDF',
    'Depth Gauge': 'Depth Gauge',
    'UT': 'UT',
    'Eval': 'Eval',
    'Change tool': 'Change tool',
    'Add photo': 'Add photo',
    'CMU': 'CMU',
    'Tool': 'Tool',
    'Residual Life': 'Residual Life',
    'Select Customer': 'Select Customer',
    'Select Filter': 'Select Filter',
    'Customer Notes': 'Customer Notes',
    'Add New': 'Add New',
    'Address To Customer Name': 'Address To Customer Name',
    'Created Date': 'Created Date',
    'Notes': 'Notes',
    'Created By': 'Created By',
    'Select Job Site': 'Select Job Site',
    'Select Equipment': 'Select Equipment',
    'Next': 'Next',
    'Save And Interpret': 'Save And Interpret',
    'Change Equipment': 'Change Equipment',
    'Review & Save': 'Review & Save',
    'General Information': 'General Information',
    'Abrasive *': 'Abrasive *',
    'Impact *': 'Impact *',
    'Moisture *': 'Moisture *',
    'Packing *': 'Packing *',
    'Observations': 'Observations',
    'Reverse Travel Kms': 'Reverse Travel Kms',
    'Reverse Travel hrs': 'Reverse Travel hrs',
    'Inspection Date *': 'Inspection Date *',
    'Meter Reading(SMU/Hourmeter) * ': 'Meter Reading(SMU/Hourmeter) * ',
    'Inches': 'Inches',
    'Change Measurement Unit': 'Change Measurement Unit',
    'Photo': 'Photo',
    'Comment': 'Comment',
    'Equipment Hours': 'Equipment Hours',
    'Forward Travel hrs': 'Forward Travel hrs',
    'Forward Travel Kms': 'Forward Travel Kms',
    'Overall Notes': 'Overall Notes',
    'Inspection Notes': 'Inspection Notes',
    'Jobsite Notes': 'Jobsite Notes',
    'Underfoot Conditions': 'Underfoot Conditions',
    'Left Chain': 'Left Chain',
    'Right Chain': 'Right Chain',
    'Left Frame': 'Left Frame',
    'Right Frame': 'Right Frame',
    'Worn(%)': 'Worn(%)',
    'Measurement': 'Measurement',
    'MM': 'MM',
    'There are currently no recommendations added for this quote. ': 'There are currently no recommendations added for this quote. ',
    'Calipers': 'Calipers',
    'Pos.': 'Pos.',
    'Worn': 'Worn',
    'Unsynced Inspections': 'Unsynced Inspections',
    'Workshop Repair Estimates': 'Workshop Repair Estimates',
    'Evaluation': 'Evaluation',
    'Select Model': 'Select Model',
    'Select Make': 'Select Make',
    'Jobsite': 'Jobsite',
    'Condition': 'Condition',
    'Actions': 'Actions',
    'How often will you be inspecting this equipment? We will use this to help forecast future inspections. ': 'How often will you be inspecting this equipment? We will use this to help forecast future inspections. ',
    'Hours per Day': 'Hours per Day',
    'Inspection Planner': 'Inspection Planner',
    'I will inspect every': 'I will inspect every',
    'On average how many days is this equipment in use, and on which days? ': 'On average how many days is this equipment in use, and on which days? ',
    'Sat': 'Sat',
    'Mon': 'Mon',
    'Tue': 'Tue',
    'Wed': 'Wed',
    'Thu': 'Thu',
    'Fri': 'Fri',
    'Sun':'Sun',
    'New SMU/Hourmeter': 'New SMU/Hourmeter',
    'What is the old SMU/Hourmeter meter reading?': 'What is the old SMU/Hourmeter meter reading?',
    'What is the new meter SMU/Hourmeter reading?': 'What is the new meter SMU/Hourmeter reading?',
    'What is the date of the replacement? ': 'What is the date of the replacement? ',
    'Old SMU/Hourmeter Reading is required': 'Old SMU/Hourmeter Reading is required',
    'Application': 'Application',
    'Ranking': 'Ranking',
    'Machine Status': 'Machine Status',
    'Please select the customer and job site where this equipment is located.': 'Please select the customer and job site where this equipment is located.',
    'Create Equipment': 'Create Equipment',
    'Would you like to setup a new equipment or modify an existing one?': 'Would you like to setup a new equipment or modify an existing one?',
    'Modify Existing Equipment': 'Modify Existing Equipment',
    'How do you identify this equipment?': 'How do you identify this equipment?',
    'What type of equipment is this?': 'What type of equipment is this?',
    'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?': 'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?',
    'You can attach a photo of this equipment which can be seen throughout the application.': 'You can attach a photo of this equipment which can be seen throughout the application. ',
    'You can also set some aditional details, although this is not required. ': 'You can also set some aditional details, although this is not required. ',
    'Select Customer & Job Site': 'Select Customer & Job Site',
    'Additional Information': 'Additional Information',
    'Serial / Unit Number': 'Serial / Unit Number',
    'SMU/Hourmeter at Setup': 'SMU/Hourmeter at Setup',
    'LTD at Setup': 'LTD at Setup',
    'Equipment Setup': 'Equipment Setup',
    'Setup Complete!': 'Setup Complete!',
    'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.': 'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.',
    'Setup Undercarriage for This Equipment': 'Setup Undercarriage for This Equipment',
    'Setup Another Equipment': 'Setup Another Equipment',
    'Equipment is not selected!': 'Equipment is not selected!',
    'Chain & Frame Details': 'Chain & Frame Details',
    'Life(When installed on equipment)': 'Life(When installed on equipment)',
    'SMU/HourMeter and Date validation passed!': 'SMU/HourMeter and Date validation passed!',
    'Date(When installed on equipment)': 'Date(When installed on equipment)',
    'Equipment SMU/Hourmeter (at install)': 'Equipment SMU/Hourmeter (at install)',
    'Review and Save': 'Review and Save',
    'This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different': 'This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different',
    'Chain': 'Chain',
    'Please add the components which will go on the chain.': 'Please add the components which will go on the chain.',
    'Grouser': 'Grouser',
    'Please add the components which will go on the frame.': 'Please add the components which will go on the frame.',
    'Cost': 'Cost',
    'Validation failed: Type is not selected!': 'Validation failed: Type is not selected!',
    'Bushing': 'Bushing',
    'Budget Life': 'Budget Life',
    'Size': 'Size',
    'Frame': 'Frame',
    'Idler': 'Idler',
    'Guard': 'Guard',
    'Track Elongation': 'Track Elongation',
    'Carrier Roller': 'Carrier Roller',
    'Track Roller': 'Track Roller',
    'Hours at Install': 'Hours at Install',
    'Date at Install': 'Date at Install',
    'Equip. SMU/Hourmeter at install': 'Equip. SMU/Hourmeter at install',
    'Setup Undercarriage on Equipment': 'Setup Undercarriage on Equipment',
    'Hrs': 'Hrs',
    'Submit': 'Submit',
    'Unlock': 'Unlock',
    'Validation failed!': 'Validation failed!',
    'Hours at install': 'Hours at install',
    'By changing equipment you will lose all your inputs!': 'By changing equipment you will lose all your inputs!',
    'Validation Passed.': 'Validation Passed.',
    'Component attached to the system successfully!': 'Component attached to the system successfully!',
    'After you have submitted the data first time round, you are unable to setup components on both sides': 'After you have submitted the data first time round, you are unable to setup components on both sides',
    'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above. ': 'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above. ',
    'Actions Required': 'Actions Required',
    'Total count of undercarriage inspections performed on a month by month basis. Filter this data down using the search above. ': 'Total count of undercarriage inspections performed on a month by month basis. Filter this data down using the search above. ',
    'JobSite is not selected!': 'JobSite is not selected!',
    'Create new system': 'Create new system',
    'Update existing': 'Update existing',
    'Life(When cerated in inventory)': 'Life(When cerated in inventory)',
    'Setup Undercarriage In Inventory': 'Setup Undercarriage In Inventory',
    'Model is not selected!': 'Model is not selected!',
    'By changing selection you will lose all your inputs!': 'By changing selection you will lose all your inputs!',
    'Setup new undercarriage': 'Setup new undercarriage',
    'Previous step validation failed!': 'Previous step validation failed!',
    'Warning': 'Warning',
    'Standard Link or Scallop Resistant Link': 'Standard Link or Scallop Resistant Link',
    'Please select the equipment.': 'Please select the equipment.',
    'You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment.': 'You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment.',
    'Examiner': 'Examiner',
    'Reset': 'Reset',
    'Evaluation (Worst Side)': 'Evaluation (Worst Side)',
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'X': 'X',
    'Start Date': 'Start Date',
    'End Date': 'End Date',
    'Single Flange' : 'Single Flange',
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    'Manage Inspection Types': 'Manage Inspection Types',
    'Left Side' : 'Left Side',
    'Language': 'Language',
    'Home Page': 'Home Page',
    'Currency': 'Currency',
    'Unit of Measurement': 'Unit of Measurement',
    'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ' :
    'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ',
    'Contact': 'Contact',
    'Full Name': 'Full Name',
    'Phone Number': 'Phone Number',
    'Address': 'Address',
    'Street Address': 'Street Address',
    'Suburb / City': 'Suburb / City',
    'Post Code': 'Post Code',
    'State': 'State',
    'Country': 'Country',
    'Dashboard - Fleet Overview': 'Dashboard - Fleet Overview',
    'Millimetres (mm)': 'Millimetres (mm)',
    'Inches (inch)': 'Inches (inch)',
    'Email Address': 'Email Address',
    'This is the email address that all emails, reports, etc. for your account will be sent to. ': 'This is the email address that all emails, reports, etc. for your account will be sent to. ',
    'Username': 'Username',
    'This is what you use to sign in to both the web application and the mobile application. ': 'This is what you use to sign in to both the web application and the mobile application. ',
    'Change Your Password': 'Change Your Password',
    'This is the password you use to sign in to both the web application and the mobile application to perform inspections on. ': 'This is the password you use to sign in to both the web application and the mobile application to perform inspections on. ',
    'New Password': 'New Password',
    'Repeat New Password': 'Repeat New Password',
    'Update Password': 'Update Password',
    'Inspections Due Emails': 'Inspections Due Emails',
    'Determines whether the sending of Inspections Due Emails is enabled or disabled. ': 'Determines whether the sending of Inspections Due Emails is enabled or disabled. ',
    'Flange width is 5.24 in. (133 mm), New tread diameter is 30.16 in. (766 mm)': 'Flange width is 5.24 in. (133 mm), New tread diameter is 30.16 in. (766 mm)',
    'Flange width is 5.21 in. (132.4 mm), New Tread diameter is 29.54 in. (750.2 mm), UT Tool only to determine flange wear only ': 'Flange width is 5.21 in. (132.4 mm), New Tread diameter is 29.54 in. (750.2 mm), UT Tool only to determine flange wear only ',
    'Measure across 3 teeth' : 'Measure across 3 teeth',
    'Flange diameter is 12.28 in. (312 mm)': 'Flange diameter is 12.28 in. (312 mm)',
    'ForwardTravelHours': 'ForwardTravelHours',
    'ReverseTravelHours': 'ReverseTravelHours',
    'ForwardTravelKms': 'ForwardTravelKms',
    'ReverseTravelKms': 'ReverseTravelKms',
    'TrackSagLeft': 'TrackSagLeft',
    'TrackSagRight': 'TrackSagRight',
    'DryJointLeft': 'DryJointLeft',
    'DryJointRight': 'DryJointRight',
    'CannonExtLeft': 'CannonExtLeft',
    'CannonExtRight': 'CannonExtRight',
    'ScallopLeft': 'ScallopLeft',
    'ScallopRight': 'ScallopRight',
    'JobsiteNotes': 'JobsiteNotes',
    'InspectionNotes': 'InspectionNotes',
    'Dealer' : 'Dealer',
    'Projected' : 'Projected',
    'Difference' : 'Difference',
    'Low' : 'Low',
    'High' : 'High',
    'Medium' : 'Medium',
    'Additional Observation Lists' : 'Additional Observation Lists',
    'Title' : 'Title',
    'Image' : 'Image',
    'Add Observations' : 'Add Observations',
    'Select equipment to create new inspection' : 'Select equipment to create new inspection',
    'Cancel' : 'Cancel',
    'Start Inspection' : 'Start Inspection',
    'Please check your user permissions, Only inspector or super user can create inspections' : 'Please check your user permissions, Only inspector or super user can create inspections',
    'There is no audit history to display.' : 'There is no audit history to display.',
    'Send Report' : 'Send Report',
    'Include Quote' : 'Include Quote',
    'Event Time' : 'Event Time',
    'Change' : 'Change',
    'Select Email Recipients': 'Select Email Recipients',
    'Send' : 'Send',
    'Add Recipient' : 'Add Recipient',
    'An Observation Description is required': 'An Observation Description is required',
    'Adding Observation List' : 'Adding Observation List',
    'Editing Observation List' : 'Editing Observation List',
    'Save Observation List' : 'Save Observation List',
    'Name' : 'Name',
    'Background Colour' : 'Background Colour',
    'Text Colour' : 'Text Colour',
    'Preview' : 'Preview',
    'Save' : 'Save',
    'Awaiting Interpretation ' : 'Awaiting Interpretation ',
    'Select System / Component' : 'Select System / Component',
    'Action Informations' : 'Action Informations',
    'Save Action' : 'Save Action',
    'Multiple Component Replacement' : 'Multiple Component Replacement',
    'Part Cost' : 'Part Cost',
    'Labour Cost' : 'Labour Cost',
    'MiscCost' : 'MiscCost',
    'Note' : 'Note',
    'Current CMU' : 'Current CMU',
    'There is no components on this system, please make sure your undercarriage setup correctly' : 'There is no components on this system, please make sure your undercarriage setup correctly',
    'Setup new System' : 'Setup new System',
    'Refresh Available Replacement List' : 'Refresh Available Replacement List',
    'There are no available replacements fits this component': 'There are no available replacements fits this component',
    'Select Swap component' : 'Select Swap component',
    'Note : There are not enough same type of rollers to swap position with on this system' : 'Note : There are not enough same type of rollers to swap position with on this system',
    'Labour Cost Option' : 'Labour Cost Option',
    'Misc Cost' : 'Misc Cost',
    'Date of Action' : 'Date of Action',
    'Times Re-builded / Re-grousered/ Re-sealed' : 'Times Re-builded / Re-grousered/ Re-sealed',
    'Total Cost' : 'Total Cost',
    'Customer hourly rate' : 'Customer hourly rate',
    'Uninstall this at SMU/Hourmeter' : 'Uninstall this at SMU/Hourmeter' ,
    'Action Against' : 'Action Against',
    'Action Histories will be affected by this action' : 'Action Histories will be affected by this action',
    'Action Date' : 'Action Date',
    'Action Name' : 'Action Name',
    'Disable' : 'Disable',
    'Enable' : 'Enable',
    'Filter By Serial Number' : 'Filter By Serial Number',
    'CMU (Average)' : 'CMU (Average)',
    'Part Number' : 'Part Number',
    'CMU (hrs)' : 'CMU (hrs)',
    '%Worn' : '%Worn',
    'Latest Action' : 'Latest Action',
    'Latest Action Date' : 'Latest Action Date',
    'Action Taken' : 'Action Taken',
    'Date' : 'Date',
    'History' : 'History',
    'Relocate System' : 'Relocate System',
    'System Notes' : 'System Notes',
    'Update Notes' : 'Update Notes',
    'Relocate To Customer' : 'Relocate To Customer',
    'Relocate To Jobsite' : 'Relocate To Jobsite',
    'Eval Overview' : 'Eval Overview',
    'Hours Component Previously Used' :'Hours Component Previously Used',
    'Please Enter Action Informations':'Please Enter Action Informations',
    'Red are Required Fields' : 'Red are Required Fields',
    'SMU/Hourmeter of Equipment at Auction Date':'SMU/Hourmeter of Equipment at Auction Date',
    'Account': 'Account',
    'General':'General',
    'Alerts':'Alerts',
    'Dashboard - Component Overview':'Dashboard - Component Overview',
    'Dashboard - Wear Rate Overview':'Dashboard - Wear Rate Overview',
    'Hours':'Hours',
    'Days':'Days',
    'Weeks':'Weeks',
    'Months':'Months',
    'Delete':'Delete',
    'Currently there is no observation list configured for this equipment':'Currently there is no observation list configured for this equipment',
    'Your Preferences':'Your Preferences',
    'You are currently missing the':'You are currently missing the',
    'Add' :'Add',
    'Customer Name':'Customer Name',
    'Right Side': 'Right Side',
    'Replace with new Chain and all Components':'Replace with new Chain and all components',
    'Replace with Chain from Inventory':'Replace with Chain from Inventory',
    'Repairs or Replacements of individual Chain Components':'Repairs or Replacements of individual Chain Components',
    'Replace with New Frame including new components':'Replace with New Frame including new components',
    'Replace frame from Inventory':'Replace frame from Inventory',
    'Repair or Replace individual Frame components':'Repair or Replace individual Frame components',
    'Replace Frame Components in Bulk':'Replace Frame Components in Bulk',
    'Which jobsite would you like to move this equipment to?':'Which jobsite would you like to move this equipment to?',
    'Update Jobsite': 'Update Jobsite',
    'SMU Reading is required':'SMU Reading is required',
    'New SMU must be greater than previous SMU':'New SMU must be greater than previous SMU',
    'New BCM must be greater than previous BCM':'New BCM must be greater than previous BCM',
    'New Tonnage must be greater than previous Tonnage':'New Tonnage must be greater than previous Tonnage',
    'New SMU' :'New SMU',
    'Old SMU/Hourmeter':'Old SMU/Hourmeter',
    'New SMU/Hourmeter Reading is required':'New SMU/Hourmeter Reading is required',
    'Invalid date: Installation date is before equipment setup date!':'Invalid date: Installation date is before equipment setup date!',
    'Equipment Setup Date: ' :'Equipment Setup Date:',
    'Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than':'Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than',
    'Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict ':'Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict ',
    'Invalid SMU/HourMeter: For ':'Invalid SMU/HourMeter: For ',
    ' SMU/HourMeter has conflict ':' SMU/HourMeter has conflict ',
    'Something is loading please try again after loading completed!':'Something is loading please try again after loading completed!',
    'You haven\'t recorded any repair costs yet.':'You haven\'t recorded any repair costs yet.',
    'Overview':'Overview',
    'Graph':'Graph',
    'Left Side - Component Wear Graph and Forecast':'Left Side - Component Wear Graph and Forecast',
    'Right Side - Component Wear Graph and Forecast':'Right Side - Component Wear Graph and Forecast',
    'Last Inspection Date SMU/Hourmeter': 'Last Inspection Date SMU/Hourmeter',
    'New Thermography Inspection':'New Thermography Inspection',
    'Overall Inspection Comment':'Overall Inspection Comment',
    'Thermography Inspection':'Thermography Inspection',
    'Jan':'Jan',
    'Feb':'Feb',
    'Mar':'Mar',
    'Apr':'Apr',
    'May':'May',
    'Jun':'Jun',
    'Jul':'Jul',
    'Aug':'Aug',
    'Sep':'Sep',
    'Oct':'Oct',
    'Nov':'Nov',
    'Dec':'Dec',
    'Items per page':'Items per page',
    'Description':'Description',
    'Currently there is no observation list configured for this inspection and this equipment':'Currently there is no observation list configured for this inspection and this equipment',
    'Hours remaining until 100% worn':'Hours remaining until 100% worn',
    'There is no audit history to display':'There is no audit history to display',
    'Error':'Error',
    'Please release this quote report first':'Please release this quote report first',
    'Add Job Site':'Add Job Site',
    'Return to Undercarriage':'Return to Undercarriage',
    'Team Administration ':'Team Administration ',
    'A team can be considered either a customer or a dealership. Each team consists of it’s own group of users who have access to equipment within that team':'A team can be considered either a customer or a dealership. Each team consists of it’s own group of users who have access to equipment within that team',
    'Add User':'Add User',
    'Add Customer':'Add Customer',
    'Users':'Users',
    'Customers':'Customers',
    'Dealerships':'Dealerships',
    'Filter user table':'Filter user table',
    'Full Name ':'Full Name ',
    'Team':'Team',
    'Access':'Access',
    'More':'More',
    'Request New Model':'Request New Model',
    'LTD is the “Life To Date” of the equipment':'LTD is the “Life To Date” of the equipment',
    'This will generally be the same as the SMU/Hour Meter reading':'This will generally be the same as the SMU/Hour Meter reading',
    'If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed.':'If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed.',
    'Date of Reading':'Date of Reading',
    'Undercarriage History ':'Undercarriage History ',
    'Select your Equipment ':'Select your Equipment ',
    'Please Select':'Please Select',
    'System S/N':'System S/N',
    'Life Lived ':'Life Lived ',
    'Life Remaining (100% Worn':'Life Remaining (100% Worn',
    'Projected Hours ':'Projected Hours ',
    'Both':'Both',
    'Show All Parts':'Show All Parts',
    'No action taken':'No action taken',
    'Never':'Never',
    'Sent':'Sent',
    'The PDF report has been emailed to all contacts successfully.':'The PDF report has been emailed to all contacts successfully.',
    'Failed to send PDF report. System Error Cannot write the document to memory. Invalid Serial Number Version.':'Failed to send PDF report. System Error Cannot write the document to memory. Invalid Serial Number Version.',
    'Recommendations included in this quote ':'Recommendations included in this quote ',
    'Distance Unit':'Distance Unit',
    'Kilometers (km)':'Kilometers (km)',
    'Miles (mi)':'Miles (mi)',
    'Forward Travel':'Forward Travel',
    'Reverse Travel':'Reverse Travel',
    'Forward':'Forward',
    'Reverse':'Reverse',
    'Create Thermography Inspection':'Create Thermography Inspection',
    'Track Sag (mm)':'Track Sag (mm)',
    'Pin Number':'Pin Number',
    'Therm L/R':'Therm L/R',
    'Left Side Additional Component':'Left Side Additional Component',
    'No Side Additional Component':'No Side Additional Component',
    'Right Side Additional Component':'Right Side Additional Component',
    
    'You haven\'t set up any equipment yet.':'You haven\'t set up any equipment yet.',
    'You don\'t have any inspection due for the selection.':'You don\'t have any inspection due for the selection.',
    'There are no inspections to display.':'There are no inspections to display.',
    'General Inspections':'General Inspections',
    'Thermography Inspections':'Thermography Inspections',
    'Both Inspections':'Both Inspections',
    'Copy to All':'Copy to All',
    'Copy to Right':'Copy to Right',
    'Done':'Done',
    'Update Equipment':'Update Equipment',
    'Undercarriage Inspection':'Undercarriage Inspection',
    'Temperature Inspection':'Temperature Inspection',

    'Severity':'Severity',
    'Manage Custom Evaluation':'Manage Custom Evaluation',
    'Set Evaluation Ranges':'Set Evaluation Ranges',
    'Set Custom Evaluation Ranges':'Set Custom Evaluation Ranges',
    'Select Level':'Select Level',
    'Please select individual machine from the search field above.':'Please select individual machine from the search field above.',
    'Equipment Level Selected':'Equipment Level Selected',
    'Select Dealer':'Select Dealer',
    'Select Jobsite':'Select Jobsite',
    'A Range':'A Range',
    'B Range':'B Range',
    'C Range':'C Range',
    'X Range':'X Range',
    'Track Shoes':'Track Shoes',
    'Track Rollers':'Track Rollers',
    'Tumblers':'Tumblers',
    'Front Idlers':'Front Idlers',
    'Rear Idlers':'Rear Idlers',
    'Crawler Frame Guide':'Crawler Frame Guide',
    'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine':'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine',
    'Thermal Images':'Thermal Images',
    'UT Equivalent':'UT Equivalent',
    'Custom Evaluation ranges do not currently apply to Rope Shovels.':'Custom Evaluation ranges do not currently apply to Rope Shovels.',
    'Additional Unit Number':'Additional Unit Number',
    'This equipment has 2 or more inspections':'This equipment has 2 or more inspections',
    'Serial/Unit Search':'Serial/Unit Search' ,
    'PMU at Setup':'PMU at Setup',
    'PMU(When installed on equipment)':'PMU(When installed on equipment)',  
    'Propel Hrs':'Propel Hrs',
    'Propel %':'Propel %',
    'Recalculate & Save':'Recalculate & Save',
    'No Undercarriage components setup': 'No Undercarriage components setup',
    'Enable Tracking by Distance Travelled': 'Enable Tracking by Distance Travelled',
    'Reading': 'Reading',
    '0% Worn': '0% Worn',
    '100% Worn': '100% Worn',
    'No Underfoot Conditions active for this family': 'Underfoot conditions not activated for this family',
    'No Observations active for this family': 'Observations not activated for this family',
    'Enable Thermal Image': 'Enable Thermal Image',
    'Manually Schedule Next Inspection': 'Manually Schedule Next Inspection',
    'Advance Forecast Settings': 'Advance Forecast Settings',
    'Display Settings- Current Forecast Status & Safety Margin': 'Display Settings- Current Forecast Status & Safety Margin',
    'Add Safety': 'Add Safety Margin',
    'Save & Update': 'Save & Update',
    'Distance Ratio': 'Hours to Distance Ratio',
    'Generate': 'Generate',
    'Next Pm Service Header': 'Next Pm \n Service',
    '2nd Pm Service Header':'2nd Pm \n Service',
    'Floating Pm1 Service Header':'Floating Pm1 \n Service',
    'Floating Pm2 Service Header':'Floating Pm2 \n Service',
    '100 % Worn Header':'100% \n Worn',
    '120 % Worn Header':'120% \n Worn',
    "Last Inspect. Worn % Header": "Last \nInspect.\n Worn % ",
    'Last Known Dist. Date Header':"Last Known \nDist. Date",
    'SMU Last Known Date Header':'SMU \nLast Known Date',
    'SMU Last Known SMU Header':'SMU \n Last Known SMU',
    'Distance Forward Header':'Distance \n Forward',
    'Distance Reverse Header':'Distance \n Reverse',
    'Last Dist. Total Header':'Last Dist. \n Total',
    'Forward Distance Header':'Forward \nDistance',
    'Reverse Distance Header':'Reverse\n Distance',
    "Season": "Season",
};
